import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import trashIcon from '@fortawesome/fontawesome-free-solid/faTrash'
import heartIcon from '@fortawesome/fontawesome-free-solid/faHeart'
import commentIcon from '@fortawesome/fontawesome-free-solid/faComment'
import userIcon from '@fortawesome/fontawesome-free-solid/faUser'
import Paper from '@material-ui/core/Paper'

import Input from '../../common/Input'

import * as feedActions from '../../../actions/Feed'
import * as configActions from '../../../actions/Config'
import * as Functions from '../../../helpers/Functions'
import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'

class FeedItems extends Component {
  constructor(props) {
    super(props)
    const commentInputs = {}

    const posts = []

    Object.keys(props.data.posts).forEach(key => {
      posts.push(props.data.posts[key])
    })

    posts.forEach(post => {
      commentInputs[post.id] = ''
    })

    this.state = {
      showAllComments: false,
      commentInputs,
      commenting: false,
      selected: null
    }
    this.inputs = []
  }

  getPosts() {
    const { data } = this.props

    const posts = []

    Object.keys(data.posts).forEach(key => {
      posts.push(data.posts[key])
    })

    return posts
  }

  renderTrashCan(postId) {
    const { user, config, data } = this.props

    if (user.isAdmin) {
      if (false) {
        return null
      }

      return (
        <a
          onClick={() =>
            this.props.showAlert(
              Strings.default.REQUEST_REMOVE_POST[config.language],
              Strings.default.REQUEST_REMOVE_POST_INFO[config.language],
              Constants.TWO_BUTTONS,
              {
                title: Strings.default.NO[config.language],
                onPress: () => {}
              },
              {
                title: Strings.default.YES[config.language],
                onPress: () => {
                  this.props.tryDeletePost(
                    user.token,
                    data.community.id,
                    postId,
                    config.language,
                    (h, i, t, b) => this.props.showAlert(h, i, t, b)
                  )
                }
              }
            )
          }
          style={{ padding: 10 }}
        >
          <FontAwesomeIcon
            icon={trashIcon}
            style={{ fontSize: 16 }}
            color={'#90949c'}
          />
        </a>
      )
    }

    return null
  }

  requestDeleteComment(postId, commentId) {
    const { config, user } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_REMOVE_COMMENT[config.language],
      Strings.default.REQUEST_REMOVE_COMMENT_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () => {
          this.props.tryDeleteComment(
            user.token,
            postId,
            commentId,
            config.language,
            (h, i, t, b) => this.props.showAlert(h, i, t, b),
            user.offlineModeSignedIn
          )
        }
      }
    )
  }

  renderComments(postId, comments) {
    const { config, data, user } = this.props
    const { showAllComments } = this.state
    const viewableComments = []

    if (showAllComments) {
      viewableComments.push(
        <a onClick={() => this.setState({ showAllComments: false })}>
          {Strings.default.HIDE_COMMENTS[config.language]}
        </a>
      )

      comments.forEach(comment =>
        viewableComments.push(
          <CommentItem
            sender={
              comment.apartment
                ? Strings.default.APARTMENT[config.language] +
                  ' ' +
                  comment.apartment.number
                : Strings.default.NOT_AVAILABLE[config.language]
            }
            onDelete={() => this.requestDeleteComment(postId, comment.id)}
            comment={comment.comment}
            myComment={comment.apartmentId === data.apartment.id}
            date={
              user.offlineModeSignedIn
                ? '1 min'
                : Functions.getTimeAgo(comment.createdAt)
            }
          />
        )
      )
    } else {
      if (comments.length > 2) {
        viewableComments.push(
          <a onClick={() => this.setState({ showAllComments: true })}>
            {Strings.default.SHOW_ALL_COMMENTS[config.language]}
          </a>
        )
      }

      if (comments.length > 0) {
        for (let i = comments.length - 2; i <= comments.length - 1; i++) {
          if (i >= 0)
            viewableComments.push(
              <CommentItem
                sender={
                  comments[i].apartment
                    ? Strings.default.APARTMENT[config.language] +
                      ' ' +
                      comments[i].apartment.number
                    : Strings.default.NOT_AVAILABLE[config.language]
                }
                onDelete={() =>
                  this.requestDeleteComment(postId, comments[i].id)
                }
                comment={comments[i].comment}
                myComment={comments[i].apartmentId === data.apartment.id}
                date={
                  user.offlineModeSignedIn
                    ? '1 min'
                    : Functions.getTimeAgo(comments[i].createdAt)
                }
              />
            )
        }
      }
    }

    return viewableComments
  }

  _handleKeyPress = e => {
    const { commentInputs, selected } = this.state
    const { config, user } = this.props

    if (e.key === 'Enter' && selected !== null) {
      if (commentInputs[selected] === '') {
        this.props.showAlert(
          Strings.default.MISSING_COMMENT_HEADER[config.language],
          Strings.default.MISSING_COMMENT[config.language],
          Constants.ONE_BUTTON,
          { title: Strings.default.OK[config.language], onPress: () => {} }
        )
      } else {
        const postData = { comment: commentInputs[selected] }
        const newInputs = { ...commentInputs }

        this.props.tryCreateComment(
          user.token,
          selected,
          postData,
          config.language,
          (h, i, t, b) => this.props.showAlert(h, i, t, b),
          user.offlineModeSignedIn
        )

        newInputs[selected] = ''

        this.setState({ commentInputs: newInputs })
      }
    }
  }

  pressComment(index) {
    this.inputs[index].focus()
  }

  render() {
    const { commentInputs } = this.state
    const { config, user, data } = this.props
    const posts = this.getPosts()

    if (posts.length === 0 && user.isAdmin) {
      return <p>{Strings.default.NO_BOOKING_SYSTEMS_ADMIN[config.language]}</p>
    }

    if (posts.length === 0) {
      return <p>{Strings.default.NO_POSTS[config.language]}</p>
    }

    return posts
      .sort(
        (o1, o2) =>
          new Date(o2.createdAt).getTime() - new Date(o1.createdAt).getTime()
      )
      .map((post, index) => {
        const myLike = post.likes.filter(
          like => like.apartmentId === data.apartment.id
        )
        const likedByMe = myLike.length > 0

        return (
          <Paper style={Styles.default.container} key={post.id}>
            <div style={Styles.default.threadPosterContainerStyle}>
              <div style={{ flexDirection: 'row', display: 'flex' }}>
                <FontAwesomeIcon
                  icon={userIcon}
                  style={{ fontSize: 40 }}
                  color={'#90949c'}
                />
                <div style={Styles.default.threadPosterStyle}>
                  <p style={Styles.default.threadPosterHeaderStyle}>
                    {Strings.default.THE_BOARD[config.language]}
                  </p>
                  <p style={Styles.default.threadPosterTimeAgoStyle}>
                    {user.offlineModeSignedIn
                      ? '1 min'
                      : Functions.getTimeAgo(post.createdAt)}
                  </p>
                </div>
              </div>
              {this.renderTrashCan(post.id)}
            </div>
            <p style={Styles.default.textStyle}>{post.text}</p>
            <div style={Styles.default.likesAndCommentsContainerStyle}>
              <div
                style={{
                  flexDirection: 'row',
                  display: 'flex'
                }}
              >
                <FontAwesomeIcon
                  icon={heartIcon}
                  style={{ fontSize: 13 }}
                  color={'#f25268'}
                />
                <p style={Styles.default.numberOfLikesStyle}>
                  {post.likes.length}
                </p>
              </div>
              <a onClick={() => this.pressComment(index)}>
                <p style={Styles.default.numberOfCommentsStyle}>
                  {post.comments.length +
                    ' ' +
                    (post.comments.length === 1
                      ? Strings.default.COMMENT[config.language].toLowerCase()
                      : Strings.default.COMMENTS[
                          config.language
                        ].toLowerCase())}
                </p>
              </a>
            </div>
            <div style={Styles.default.likeOrCommentContainerStyle}>
              <a
                style={Styles.default.likeOrCommentButtonStyle}
                onClick={() => {
                  if (likedByMe) {
                    this.props.tryDeleteLike(
                      user.token,
                      post.id,
                      data.apartment.id,
                      config.language,
                      (h, i, t, b) => this.props.showAlert(h, i, t, b),
                      user.offlineModeSignedIn
                    )
                  } else {
                    this.props.tryLike(
                      user.token,
                      post.id,
                      config.language,
                      (h, i, t, b) => this.props.showAlert(h, i, t, b),
                      user.offlineModeSignedIn
                    )
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={heartIcon}
                  style={{ fontSize: 17 }}
                  color={likedByMe ? '#f25268' : '#90949c'}
                />
                <p
                  style={{
                    color: likedByMe ? '#f25268' : '#90949c',
                    margin: 0,
                    marginLeft: 5
                  }}
                >
                  {Strings.default.LIKE[config.language]}
                </p>
              </a>
              <a
                style={Styles.default.likeOrCommentButtonStyle}
                onClick={() => this.pressComment(index)}
              >
                <FontAwesomeIcon
                  icon={commentIcon}
                  style={{ fontSize: 17 }}
                  color={'#90949c'}
                />
                <p style={{ color: '#90949c', margin: 0, marginLeft: 5 }}>
                  {Strings.default.MAKE_COMMENT[config.language]}
                </p>
              </a>
            </div>
            {this.renderComments(post.id, post.comments)}
            <Input
              placeholder={Strings.default.COMMENT[config.language]}
              value={this.state.commentInputs[post.id]}
              onChange={text => {
                const newInputs = { ...commentInputs }

                newInputs[post.id] = text

                this.setState({ commentInputs: newInputs })
              }}
              onKeyPress={this._handleKeyPress}
              onRef={instance => {
                this.inputs[index] = instance
              }}
              onFocus={() => this.setState({ selected: post.id })}
              onBlur={() => this.setState({ selected: null })}
            />
          </Paper>
        )
      })
  }
}

const CommentItem = ({ comment, date, myComment, onDelete, sender }) => {
  return (
    <div style={Styles.default.commentContainer}>
      <FontAwesomeIcon
        icon={userIcon}
        style={{ fontSize: 25, marginRight: 7, marginLeft: '1%' }}
        color={'#90949c'}
      />
      <div style={Styles.default.innerCommentContainer}>
        <div style={Styles.default.informationCommentContainer}>
          <p style={Styles.default.senderText}>{sender}</p>
          <p style={Styles.default.date}>{date}</p>
        </div>
        <p style={Styles.default.comment}>{comment}</p>
      </div>
      {myComment ? (
        <a onClick={() => onDelete()}>
          <FontAwesomeIcon
            icon={trashIcon}
            style={{ fontSize: 16, marginLeft: 6 }}
            color={'#90949c'}
          />
        </a>
      ) : null}
    </div>
  )
}

function mapStateToProps({ user, feed, config, data }) {
  return { user, feed, config, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...feedActions, ...configActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedItems)



// WEBPACK FOOTER //
// ./src/components/containers/FeedItems/index.js